import React from 'react';
import {baseUrl} from "./requestConfig";

const JoditConfig =
    {
        debugLanguage: false,
        tabIndex: -1,
        toolbar: true,
        enter: 'P',
        useSplitMode: false,
        colorPickerDefaultTab: 'background',
        imageDefaultWidth: 100,
        disablePlugins: ['paste', 'stat'],
        events: {},
        textIcons: false,
        showXPathInStatusbar: false,
        toolbarInline: true,
        readonly: false,
        placeholder: 'چیزی بنویسید...',
        direction: "rtl",
        height: '35vh',
        addNewLine: false,
        allowResizeY: true,
        allowResizeX: false,
        fullsize: false,
        hidePoweredByJodit: true,
        spellcheck: false,
        language: "fa",
        i18n: {
            fa: "fa"
        },
        zIndex: 1,
        toolbarButtonSize: 'middle',
        theme: 'default',
        enableDragAndDropFileToEditor: true,
        saveModeInCookie: false,

        editorCssClass: false,
        triggerChangeEvent: true,
        showTooltip: true, controls: {
            font: {
                list: {
                "IRANSans": "IRANSans, sans-serif"
            }
        }
    },

        uploader: {
            insertImageAsBase64URI: false,
            url: baseUrl + '/api/moderate/articles/upload-image',
            format: 'json',
            headers: {
                'Authorization': localStorage.getItem('token') || ""
            },
            buildData: (data) => {
                return data;
            },
            isSuccess: (resp) => {
                return resp && !resp?.error;
            },
            getMessage: (resp) => {
                return resp?.msg || "خطا در بارگذاری رسانه";
            },
            process: (resp) => {

                return {
                    files: resp.data.files || [],
                    path: resp.data.path,
                    baseurl: resp.data.baseurl,
                    error: resp.error,
                    msg: resp.data.messages
                };
            },
        defaultHandlerSuccess: function (data, resp) {
            let i,
                field = 'files';
            if (data[field] && data[field].length) {
                for (i = 0; i < data[field].length; i += 1) {
                    this.s.insertImage(data.baseurl + data[field][i]);
                }
            }
        },
            error: (e) => {
                console.log(e)
            }
        }
    };

export default JoditConfig;